import type { SetStateAction } from 'react';
import { createContext, useContext } from 'react';

type IdeasContext = {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  scroll: (direction: 'next' | 'previous') => void;
  setCanScrollLeft: (value: SetStateAction<boolean>) => void;
  setCanScrollRight: (value: SetStateAction<boolean>) => void;
  setScroll: (value: (direction: 'next' | 'previous') => void) => void;
};

const defaultValue: IdeasContext = {
  canScrollLeft: true,
  canScrollRight: true,
  scroll: () => {},
  setCanScrollLeft: () => {},
  setCanScrollRight: () => {},
  setScroll: () => {},
};

const context = createContext(defaultValue);
const { Provider } = context;
const useIdeas = (): IdeasContext => useContext(context);

export { IdeasContext, Provider, defaultValue, useIdeas };
